<!-- token -->
@if (tokenParams$ | async; as token) {
  <mat-progress-bar
    class="position-absolute top-0 start-0"
    color="primary"
    mode="indeterminate"
    value="100"
  ></mat-progress-bar>
}
@if (!hide) {
  <!--/ token -->
  <!-- <p style="color: white; position:absolute;">Atualizado: 03-07-2023</p> -->
  @if (showVersion) {
    <p class="m-0 position-absolute top-0 mt-2 ms-2">
      <ngb-alert
        type="primary"
        (closed)="close()"
        class="m-0"
        [@bounceInOnEnter]="{ value: '', params: { duration: 1000 } }"
      >
        <div class="d-flex gap-3 align-items-center">
          <span class="material-symbols-outlined balanco text-ergon">
            notifications
          </span>
          @if (dataProd$ | async; as atualizacao) {
            <span
              >Última atualização:
              @if (mostrarDataProd) {
                <time class="text-danger" [@fadeInOnEnter]="mostrarDataProd">
                  {{ atualizacao | date: "dd/MM/yyyy - HH:mm" }}
                </time>
              } @else {
                <time [@fadeInOnEnter]="mostrarDataProd">
                  {{ atualizacao | date: "dd/MM/yyyy" }}
                </time>
              }
            </span>
          }
        </div>
      </ngb-alert>
    </p>
  }
  <div id="login">
    <div class="container flex-column">
      <div class="container-login" [class.login-sem-mascote]="!exibirMascote">
        @if (exibirMascote) {
          <div class="images-login">
            <img
              [@bounce]
              ngSrc="assets/img/mascote_professor.webp"
              class="mascote"
              alt="mascote-professor-direita"
              width="392"
              height="400"
              priority
            />
            <div class="image-background"></div>
          </div>
        }

        <div class="form-login">
          <div class="logo-mobile" [@bounce] [@fadeInOnEnter]>
            <img
              ngSrc="assets/img/logo_gep_1.svg"
              width="167"
              height="88"
              priority
              alt="logo do gep"
            />
          </div>

          <form
            class="row g-4 needs-validation"
            [formGroup]="form"
            (ngSubmit)="submit()"
            novalidate
          >
            <div class="col-md-12">
              <label for="InputCpf" class="form-label">Usuário:</label>
              <div class="input-group">
                <span class="input-group-text" id="basic-addon1"
                  ><span class="material-symbols-outlined">person</span></span
                >
                <input
                  mask="000.000.000-00"
                  [dropSpecialCharacters]="false"
                  inputmode="numeric"
                  type="text"
                  name="user"
                  class="form-control"
                  id="InputCpf"
                  placeholder="Digite o CPF"
                  maxlength="14"
                  formControlName="cpf"
                  required
                />
              </div>

              <div id="cpf-msg">
                <div class="d-flex align-items-center">
                  @if (msgErro) {
                    <span class="msg-1 {{ msgColor }}">{{
                      msgErro
                    }}</span>
                  }
                  <span
                    class="material-symbols-outlined {{ msgColor }}"
                    style="font-size: 10px"
                    >{{ msgIcon }}</span
                  >
                </div>
              </div>
            </div>

            <!-- [ngStyle]="listaBanco.length === 1 ? {'visibility': 'hidden'} : {'visibility': 'visible'}" -->
            @if (listaBanco.length > 1) {
              <div class="col-md-12" @fade>
                <label for="InputLocal">Local:</label>
                <div class="input-group">
                  <span class="input-group-text" id="basic-addon1"
                    ><span class="material-symbols-outlined">search</span></span
                  >
                  <input
                    autocomplete="off"
                    class="form-control municipio"
                    list="datalistOptions"
                    id="local"
                    placeholder="Selecione o local"
                    formControlName="local"
                    required
                    (change)="validarLocal()"
                  />
                  <datalist id="datalistOptions">
                    @if (listaBanco.length === 0) {
                      <option value="" disabled>Digite o cpf primeiro</option>
                    } @else {
                      @for (banco of listaBanco; track banco.ID) {
                        <option [value]="banco?.CLIENTE">{{ banco?.CLIENTE }}</option>
                      }
                    }
                  </datalist>
                </div>
                @if (localInvalido) {
                  <small class="text-danger">local inválido</small>
                }
              </div>
            }

            <div class="col-md-12">
              <label
                for="InputSenha"
                class="form-label"
                (click)="logarComSuporte()"
                >Senha:</label
              >
              <div class="input-group">
                <span class="input-group-text" id="basic-addon1"
                  ><span class="material-symbols-outlined">lock</span></span
                >
                <input
                  name="password"
                  type="password"
                  class="form-control"
                  id="InputSenha"
                  placeholder="Digite sua senha"
                  formControlName="senha"
                  required
                />
              </div>
            </div>

            <div class="col-md-12">
              <label for="InputAnoLetivo">Ano letivo:</label>
              <div class="input-group">
                <span class="input-group-text" id="basic-addon1"
                  ><span class="material-symbols-outlined"
                    >edit_calendar</span
                  ></span
                >
                <select
                  class="form-select ano-letivo"
                  aria-label="select example"
                  id="InputAnoLetivo"
                  required
                  formControlName="ano"
                >
                  @for (year of listYear; track year) {
                    <option [value]="year">{{ year }}</option>
                  }
                </select>
              </div>
            </div>

            <div class="d-flex justify-content-center">
              @if (!loading) {
                <button
                  class="btn btn-ergon btn-shadow"
                  type="submit"
                  [disabled]="form.invalid || carregando"
                >
                  Entrar
                </button>
              } @else {
                <button class="btn btn-light" type="button" disabled>
                  <span
                    class="spinner-grow spinner-grow-sm"
                    role="status"
                  ></span>
                  Entrando...
                </button>
              }
            </div>
          </form>

          <div
            class="col-12 campo-btn-recuperar-senha d-flex align-items-center justify-content-center mt-2"
          >
            <span
              class="btn recuperar-senha"
              (click)="esqueceuSenha()"
              (keydown.enter)="esqueceuSenha()"
              tabindex="0"
              ><u>Esqueceu a senha?</u></span
            >
            <span>|</span>
            <span
              class="btn recuperar-senha"
              (click)="alterarSenha()"
              (keydown.enter)="alterarSenha()"
              tabindex="0"
              >Alterar senha</span
            >
          </div>
        </div>
        @if (form.get('cpf')?.invalid && form.get('cpf')?.touched) {
          <app-mensagem
            mensagem="CPF obrigatório"
            style="position: absolute; bottom: 0; right: 10px"
          ></app-mensagem>
        }
        @if (form.get('senha')?.invalid && form.get('senha')?.touched) {
          <app-mensagem
            mensagem="Senha obrigatório"
            style="position: absolute; bottom: 0; right: 10px"
          ></app-mensagem>
        }
        @if (form.get('local')?.invalid && form.get('local')?.touched) {
          <app-mensagem
            mensagem="Para escolher um local você deve digitar um CPF"
            style="position: absolute; bottom: 0; right: 10px"
          >
          </app-mensagem>
        }
      </div>

      <div class="text-center">
        <small style="color: #fff"
          ><a
            [href]="footerLinkUrl"
            class="link-footer"
            target="_blank"
            rel="noopener noreferrer"
            >{{ footerTexto }}</a
          ></small
        >
      </div>
    </div>
  </div>

}
